export interface EventTeleport {
  position: string;
  rotation: string;
}
